import React from 'react';
import { Link } from 'react-router-dom';
import { Logo } from 'components/Logo';
import { useLanguage } from 'lib/i18n';
import { LanguageSwitcher } from 'components/LanguageSwitcher';

export default function TermsPage() {
  const { t } = useLanguage();
  return (
    <div className="min-h-screen bg-background">
      <div className="max-w-3xl mx-auto px-6 py-10">
        <div className="flex items-center justify-between"><Link to="/"><Logo /></Link><LanguageSwitcher /></div>
        <h1 className="text-3xl font-bold mt-8 mb-6">{t('legal.termsTitle')}</h1>
        <div className="prose prose-sm max-w-none text-muted-foreground space-y-4">
          <p>{t('legal.terms1')}</p>
          <p>{t('legal.terms2')}</p>
          <p>{t('legal.terms3')}</p>
          <p>{t('legal.terms4')}</p>
        </div>
        <h2 id="privacy" className="text-2xl font-bold mt-10 mb-6">{t('legal.privacyTitle')}</h2>
        <div className="prose prose-sm max-w-none text-muted-foreground space-y-4">
          <p>{t('legal.privacy1')}</p>
          <p>{t('legal.privacy2')}</p>
        </div>
        <p className="text-xs text-muted-foreground mt-10">{t('legal.version')}</p>
      </div>
    </div>
  );
}
